<!--
  输入号码
  jay 2020-00-24
 -->
<template>
  <div>
    <div class="input-box">
      <div class="input-title" v-if="operatorTitle.length">
        <span v-for="(item, index) in operatorTitle" :key="index">
          {{ item }}
        </span>
      </div>
      <div class="show-tab">
        <a :class="{ active: showNumber == 0 }" @click="showNum(0)">
          {{ $t("recharge.totalNumber") }}:
          {{ Alltotal }}
          {{ $t("recharge.article") }}
        </a>
        <a :class="{ active: showNumber == 1 }" @click="showNum(1)">
          {{ $t("recharge.wrongNumber") }}:
          {{ errorArr.length }}
          {{ $t("recharge.article") }}
        </a>
        <a :class="{ active: showNumber == 2 }" @click="showNum(2)">
          {{ $t("recharge.duplicateNumber") }}:
          {{ repeatArr.length }}
          {{ $t("recharge.article") }}
        </a>
      </div>
      <div class="text-warp">
        <van-field
          v-model="phone"
          ref="textarea"
          @blur="inputBlur(phone)"
          type="textarea"
          :placeholder="$t('recharge.enterNumberTips')"
        />
      </div>
      <div class="operate">
        <div class="item">
          <span>
            <a @click="tagAddFun">{{ $t("recharge.addLabel") }}</a>
          </span>
          <span>
            <a
              :class="{ 'text-gray': !tagList.length }"
              @click="tagImportFun"
              >{{ $t("recharge.importNumber") }}</a
            >
          </span>
          <span>
            <a @click="showTagFun">{{ $t("recharge.addFavoriteNumber") }}</a>
          </span>
        </div>
        <div class="item">
          <span>
            <a class="text-orange" @click="deleteSubmit(0)">{{
              $t("recharge.wrongRemoval")
            }}</a>
          </span>
          <span>
            <a class="text-orange" @click="deleteSubmit(1)">{{
              $t("recharge.repetitiveRemoval")
            }}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    operatorTitle: {
      //充值号码的运营商列表
      type: Array,
      default: function() {
        //title 充值号码的运营商列表
        //type 充值号码运营商的类别 0是Globe(Tm) Smart Sun 1是Globe Smart Sun Tm 2是Tnt
        return [];
      }
    },
    operatorType: {
      //充值号码运营商的类别 0是Globe(Tm) Smart Sun 1是Globe Smart Sun Tm 2是Tnt
      type: Number,
      default: function() {
        return 0;
      }
    },
    numberIndex: {
      //文本框索引当前索引
      type: Number,
      default: function() {
        return 0;
      }
    },
    operatorList: {
      //运营商号码段列表
      type: Array,
      default: function() {
        return [];
      }
    },
    allMoney: {
      // 所有金额面板信息
      type: Object,
      default: function() {
        return {};
      }
    },
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    tagImportMobile: {
      //标签号码
      type: Array,
      default: function() {
        return [];
      }
    },
    tagImportFlag: {
      //导入标签显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    tagAddFlag: {
      //添加标签显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    tagAddMobile: {
      //添加标签号码数组
      type: Array,
      default: function() {
        return [];
      }
    },
    showTagFlag: {
      //常用号码号码显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  components: {},
  data() {
    return {
      showNumber: 0, //显示全部/错误/重复号码

      telArr: [], //导入的号码数组
      phone: "", //输入框的号码
      successArr: [], //输入的号码的成功数组
      errorArr: [], //输入的号码的错误数组
      repeatArr: [], //输入的号码的重复数组
      Alltotal: 0 //总条数
    };
  },
  created() {},
  mounted() {
    let vm = this;
    vm.showNumber = 0; //显示全部/错误/重复号码
    vm.telArr = []; //导入的号码数组
    vm.phone = ""; //输入框的号码
    vm.successArr = []; //输入的号码的成功数组
    vm.errorArr = []; //输入的号码的错误数组
    vm.repeatArr = []; //输入的号码的重复数组
    vm.Alltotal = 0; //总条数
  },
  computed: {},
  methods: {
    showTagFun() {
      //常用号码
      this.$emit("update:showTagFlag", true);
    },
    tagAddFun() {
      //添加标签
      this.$emit("update:tagAddFlag", true);
    },
    tagImportFun() {
      //导入号码，调用父组件
      if (this.tagList.length) {
        this.$emit("getNumberIndex", this.numberIndex);
        this.$emit("update:tagImportFlag", true);
      }
    },
    showNum(type) {
      //显示当前的号码
      let vm = this;
      vm.$refs.textarea.blur();
      vm.showNumber = type;
      let newArr = [];
      if (type == 0) {
        newArr = JSON.parse(JSON.stringify(vm.telArr));
      } else if (type == 1) {
        newArr = JSON.parse(JSON.stringify(vm.errorArr));
      } else if (type == 2) {
        newArr = JSON.parse(JSON.stringify(vm.repeatArr));
      }
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      vm.phone = newArr.join(";\n");
    },
    inputBlur(val) {
      //输入号码
      let vm = this;
      if (val == "") {
        //判断当前显示的号码
        let newArr = [];
        if (vm.showNumber == 0) {
          vm.telArr = [];
          vm.errorArr = [];
          vm.repeatArr = [];
          vm.successArr = [];
        } else if (vm.showNumber == 1) {
          vm.errorArr = [];
        } else if (vm.showNumber == 2) {
          vm.repeatArr = [];
        }
        newArr = newArr
          .concat(vm.successArr)
          .concat(vm.errorArr)
          .concat(vm.repeatArr);
        vm.telArr = JSON.parse(JSON.stringify(newArr));
        vm.Alltotal = vm.telArr.length;
        return;
      }
      let newStr = val + "";
      // console.log(newStr.replace(/；/g, '@'))
      //处理换行和；分号，方便转换成数组
      newStr = newStr.replace(/\n/g, "@");
      newStr = newStr.replace(/;/g, "@");
      newStr = newStr.replace(/；/g, "@");
      //清除数据中的空格
      newStr = newStr.replace(/\s/g, "");
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      if (newStr.split("@").length) {
        let thisArr = [];
        thisArr = newStr.split("@");
        thisArr = vm.trimSpace(thisArr);
        if (vm.showNumber == 0) {
          //修改全部数据,则修改的是全部数据
          newArr = thisArr;
        } else if (vm.showNumber == 1) {
          //修改错误数据
          newArr = [];
          newArr = newArr
            .concat(thisArr)
            .concat(vm.repeatArr)
            .concat(vm.successArr);
        } else if (vm.showNumber == 2) {
          //修改重复数据
          newArr = [];
          newArr = newArr
            .concat(thisArr)
            .concat(vm.errorArr)
            .concat(vm.successArr);
        }
        vm.telArr = JSON.parse(JSON.stringify(newArr));
        vm.updateMobile();
      }
    },
    trimSpace(array) {
      //去掉数组中的空字符串
      for (var i = 0; i < array.length; i++) {
        if (
          array[i] == "" ||
          array[i] == null ||
          typeof array[i] == "undefined"
        ) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    updateMobile() {
      //校验号码
      let vm = this;
      // console.log(regArr)
      let errorArr = [];
      let successArr = [];
      // console.log(vm.telArr)
      for (let i = 0; i < vm.telArr.length; i++) {
        //先判断号码是否符合规则
        //是否是以09/09/8/9开头，并且是11/10位数字
        let thisNum = Number(vm.telArr[i]);
        let thisFirst = thisNum.toString().split("")[0];
        let thisLength = thisNum.toString().length;
        if ((thisFirst == "8" || thisFirst == "9") && thisLength == 10) {
          //再判断是否存在当前运营商号码段中，不存在则是错误号码
          let thisPhone = "0" + thisNum;
          let exist = false;
          for (let j = 0; j < vm.operatorList.length; j++) {
            let thisReg = vm.operatorList[j].tel + "";
            if (vm.operatorType == 2) {
              // TNT
              if (
                thisPhone.indexOf(thisReg) == 0 &&
                vm.operatorList[j].operator_id == 2
              ) {
                exist = true;
                break;
              }
            } else {
              if (thisPhone.indexOf(thisReg) == 0) {
                exist = true;
                break;
              }
            }
          }
          if (exist) {
            //判断成功数组中是否有该号码
            successArr.push(thisPhone);
          } else {
            //添加至错误号码中
            errorArr.push(vm.telArr[i]);
          }
        } else {
          //添加至错误号码中
          errorArr.push(vm.telArr[i]);
        }
      }
      //所有正确号码补0
      for (let i = 0; i < vm.telArr.length; i++) {
        for (let j = 0; j < successArr.length; j++) {
          if (Number(vm.telArr[i]) == Number(successArr[j])) {
            vm.telArr[i] = "0" + Number(vm.telArr[i]);
          }
        }
      }
      let newSuccess = [];
      let repeatArr = [];
      //正确的号码补0之后再判断是否存在重复号码
      for (let i = 0; i < successArr.length; i++) {
        if (newSuccess.indexOf(successArr[i]) == -1) {
          //判断newSuccess中是否包含当前号码，没有则添加
          newSuccess.push(successArr[i]);
        } else {
          repeatArr.push(successArr[i]);
        }
      }
      //赋值数组
      vm.successArr = JSON.parse(JSON.stringify(newSuccess));
      vm.repeatArr = JSON.parse(JSON.stringify(repeatArr));
      vm.errorArr = JSON.parse(JSON.stringify(errorArr));
      //渲染至页面
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      //赋值输入框
      vm.phone = newArr.join(";\n");
      //条数显示
      vm.Alltotal = vm.telArr.length; //总条数
      //展示当前选择的显示的数据
      vm.showNum(vm.showNumber);
      console.log("正确号码", vm.successArr);
      console.log("错误号码", vm.errorArr);
      console.log("重复号码", vm.repeatArr);
      //把输入框中的号码传给父组件，用于添加号码到标签
      vm.$emit("update:tagAddMobile", vm.telArr);
    },
    getClassify(flag) {
      debugger
      //将号码分组
      let vm = this;
      let successArr = [];
      if (flag) {
        //父组件点击下一步判断是否有重复号码
        //如果点击确认,则将重复号码加入正确的数组中
        successArr = JSON.parse(
          JSON.stringify(vm.successArr.concat(vm.repeatArr))
        );
      } else {
        successArr = JSON.parse(JSON.stringify(vm.successArr));
      }
      //先将号码段根据当前充值方式以及需要的号码段列别处理一下
      let newArr = JSON.parse(JSON.stringify(vm.operatorList));
      // 1Globe、2Smart、3Sun、4Tnt、5Tm
      let classArr = [];
      for (let num = 0; num < 6; num++) {
        let obj = {};
        let index = num + 1;
        obj.name = "";
        obj.operator_id = index;
        obj.phones = [];
        obj.amount = 0;
        obj.denomination_id = 0;
        obj.content = "";
        obj.showAll = false;
        if (vm.operatorType == 0) {
          obj.denomination = vm.allMoney[index].denomination;
          obj.operator_recharge = vm.allMoney[index].operator_recharge;
          obj.recently = vm.allMoney[index].previous_record;
        }
        classArr.push(obj);
      }
      for (let i = 0; i < newArr.length; i++) {
        for (let j = 0; j < successArr.length; j++) {
          let thisReg = newArr[i].tel + "";
          if (successArr[j].indexOf(thisReg) == 0) {
            let operatorId = newArr[i].operator_id;
            for (let k = 0; k < classArr.length; k++) {
              if (classArr[k].operator_id == operatorId) {
                classArr[k].name = newArr[i].name;
                classArr[k].phones = classArr[k].phones.concat(successArr[j]);
              }
            }
          }
        }
      }
      if (vm.operatorType == 0) {
        //需要Globe Smart Sun，注意，这里需要将tm的号码段合并到Globe中
      } else if (vm.operatorType == 1) {
        //需要Globe Smart Sun Tm
      } else if (vm.operatorType == 2) {
        //需要新增Tnt,Tnt的号码段实际上是等于Smart的号码段，赋值即可
        //并将Smart的号码段清空
        let TntArr = [];
        for (let i = 0; i < classArr.length; i++) {
          let obj = {};
          if (classArr[i].operator_id == 2) {
            obj = classArr[i];
            obj.operator_id = 4;
            obj.name = "Tnt";
            TntArr.push(obj);
          }
        }
        classArr = TntArr;
      }
      let needArr = [];
      for (let i = 0; i < classArr.length; i++) {
        if (classArr[i].phones.length) {
          needArr.push(classArr[i]);
        }
      }
      let data = {};
      data.arr = needArr;
      if (vm.repeatArr.length) {
        data.repeat = true;
      }
      if (vm.errorArr.length) {
        data.error = true;
      }
      return data;
    },
    deleteSubmit(type) {
      //去错去重
      let vm = this;
      vm.$refs.textarea.blur();
      let newArr = [];
      if (type || type == 0) {
        if (type == 0) {
          if (!vm.errorArr.length) {
            return;
          }
          vm.errorArr = [];
          newArr = JSON.parse(
            JSON.stringify(vm.successArr.concat(vm.repeatArr))
          );
        } else {
          if (!vm.repeatArr.length) {
            return;
          }
          vm.repeatArr = [];
          newArr = JSON.parse(
            JSON.stringify(vm.successArr.concat(vm.errorArr))
          );
        }
      } else {
        vm.errorArr = [];
        vm.repeatArr = [];
        newArr = JSON.parse(JSON.stringify(vm.successArr));
      }
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      vm.telArr = JSON.parse(JSON.stringify(newArr));
      vm.phone = newArr.join(";\n");
      vm.Alltotal = vm.telArr.length;
      vm.showNum(vm.showNumber);
    }
  },
  watch: {
    tagImportMobile() {
      //导入标签时，将号码渲染
      let vm = this;
      if (vm.tagImportMobile.length) {
        vm.inputBlur(vm.tagImportMobile.join(";"));
        //导入完成后，清空标签数组
        vm.$emit("update:tagImportMobile", []);
      }
    },
    operatorType() {
      let vm = this;
      vm.showNumber = 0; //显示全部/错误/重复号码
      vm.telArr = []; //导入的号码数组
      vm.phone = ""; //输入框的号码
      vm.successArr = []; //输入的号码的成功数组
      vm.errorArr = []; //输入的号码的错误数组
      vm.repeatArr = []; //输入的号码的重复数组
      vm.Alltotal = 0; //总条数
    }
  }
};
</script>

<style lang="less" scoped>
.input-box {
  padding: 16px 12px;
  .input-title {
    margin-bottom: 8px;
    color: #4a4a4a;
    font-size: 16px;
    font-weight: 500;
    span {
      margin-right: 10px;
    }
  }
}

.show-tab {
  padding-bottom: 10px;
  a {
    font-size: 12px;
    color: #cacaca;
    font-weight: 500;
    padding: 0 10px;
    &:first-child {
      padding-left: 0;
    }
    &.active {
      color: #2042ab;
      position: relative;
    }
    &.active::after {
      content: "";
      height: 3px;
      width: calc(100% - 20px);
      border-radius: 3px;
      background: #2042ab;
      position: absolute;
      left: 10px;
      bottom: -10px;
    }
    &.active:first-child::after {
      width: calc(100% - 10px);
      left: 0;
    }
  }

  a + a {
    border-left: 1.1px solid #b6b6b6;
  }
}

.text-warp {
  width: 100%;
  height: 248px;
  border: 1.1px solid #b6b6b6;
  border-radius: 5px;
  overflow: hidden;

  /deep/.van-cell,
  /deep/.van-field__body,
  /deep/.van-field--min-height .van-field__control {
    height: 100%;
    font-size: 16px;
    line-height: 22px;
  }
}

.operate {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .item:first-child {
    margin-right: 10px;
    span + span {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -6px;
        height: 12px;
        border-left: 1.1px solid #b6b6b6;
      }
    }
  }
  .item:last-child {
    flex: 1;
    justify-content: flex-end;
  }
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      padding: 0 6px;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
      a {
        color: #2042ab;
        &.text-gray {
          color: #9b9b9b;
        }
        &.text-orange {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
